import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Container, Col, Dropdown, DropdownButton, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { BiHelpCircle, BiHide, BiShow, BiTrash } from "react-icons/bi";
import DeleteConfirmDialog from './DeleteConfirmDialog';
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import { UserContext } from "../UserContext";
import { PencilIcon } from "@primer/octicons-react";
import { LoadingSpinner, validateEmail } from '../utils/uiUtils';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import configInfo from '../config/config.json';
import "./AdminPages.css";


function UserProfileBody() {

  // Utilities
  const { i18n, t } = useTranslation(['common','custom']);

  // ----- UI Stuff -----

  const lngList = [
    { key: "en",    value: "en" },
    { key: "zh_CN", value: "zh_CN" },
    { key: "zh_HK", value: "zh_HK" }
  ];

  const [secQuestionList,       setSecQuestionList]       = useState([]);
  const [platformConfig,        setPlatformConfig]        = useState([]);

  // View vs Edit Modes
  const [editModeName,          setEditModeName]          = useState(false);
  const [editModeContactInfo,   setEditModeContactInfo]   = useState(false);
  const [editModePhoto,         setEditModePhoto]         = useState(false);
  const [editModeOtherSettings, setEditModeOtherSettings] = useState(false);
  const [editModePassword,      setEditModePassword]      = useState(false);
  const [editModeSecQnA,        setEditModeSecQnA]        = useState(false);
  const [editModeMFA,           setEditModeMFA]           = useState(false);

  const { user } = useContext(UserContext);

  // Initialize with actual JSON obj.  If not, will get error.
  const [userAttrs, setUserAttrs] = useState({
    username: '',
    userType: '',
    email: '',
    surname: '',
    givenName: '',
    middleName: '',
    mobilePhone: '',
    workPhone: '',
    deptNameCode: '',
    mfa: '',
    language: '',
    status: '',
    timeCreated: '',
    timePwdUpdated: '',
    timeUpdated: ''
  });

  const [photoUrl,                setPhotoUrl]                = useState('');
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [errMsgDeleteConfirm,     setErrMsgDeleteConfirm]     = useState('')

  const [newName, setNewName] = useState(
    {
      surname:    '',
      givenName:  '',
      middleName: ''
    }
  );

  const [newContactInfo, setNewContactInfo] = useState(
    {
      email:       '',
      mobilePhone: '',
      workPhone:   ''
    }
  );

  const [newPhotoInfo, setNewPhotoInfo] = useState(
    {
      fileType: '',
      fileExt : '',
      size: 0,
      data: null
    }
  );

  const [newPassword, setNewPassword] = useState(
    {
      password:        '',
      confirmPassword: '',
      currentPassword: ''
    }
  );

  const [newSecQnA, setNewSecQnA] = useState(
    {
      secQuestion: '',
      secAnswer:   '',
      currentPassword2:   ''
    }
  );

  const [newMfa, setNewMfa] = useState(
    {
      currentPassword3:   ''
    }
  );

  const [newMfaWithEmail, setNewMfaWithEmail] = useState(false);
  const [newMfaWithSMS,   setNewMfaWithSMS]   = useState(false);
  const [newLng,          setNewLng]          = useState({});

  let { surname, givenName, middleName } = newName;
  let { email, mobilePhone, workPhone } = newContactInfo;
  let { password, confirmPassword, currentPassword } = newContactInfo;
  let { secQuestion, secAnswer, currentPassword2 } = newSecQnA;
  let { currentPassword3 } = newMfa;

  const [loading, setLoading] = useState(false);

  const [hideNewPwd,      setHideNewPwd]      = useState(true);
  const [hideConfirmPwd,  setHideConfirmPwd]  = useState(true);
  const [hideCurrentPwd,  setHideCurrentPwd]  = useState(true);
  const [hideCurrentPwd2, setHideCurrentPwd2] = useState(true);
  const [hideCurrentPwd3, setHideCurrentPwd3] = useState(true);

  const [mainErrMsg,             setMainErrMsg]             = useState('');
  const [newNameErrMsg,          setNewNameErrMsg]          = useState('');
  const [newContactInfoErrMsg,   setNewContactInfoErrMsg]   = useState('');
  const [newPhotoErrMsg,         setNewPhotoErrMsg]         = useState('');
  const [newOtherSettingsErrMsg, setNewOtherSettingsErrMsg] = useState('');
  const [newPasswordErrMsg,      setNewPasswordErrMsg]      = useState('');
  const [newSecQnAErrMsg,        setNewSecQnAErrMsg]        = useState('');
  const [newMfaErrMsg,           setNewMfaErrMsg]           = useState('');


  // Initialize state
  useEffect(() => {

    fetchUserAttrs(user.userInfo.username);
    fetchSecQuestions();
    fetchPlatformConfig();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- API Stuff -----

  // API functions
  const fetchUserAttrs = (username) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("curr-user-info/");

        resolve(res.data);

        if (res.status === 200) {

          setUserAttrs(res.data);  // ### May need to mask the userId, which is internal info ###

          setNewName({
            surname:    res.data.surname    ? res.data.surname :    '',
            givenName:  res.data.givenName  ? res.data.givenName :  '',
            middleName: res.data.middleName ? res.data.middleName : ''
          });

          setNewContactInfo({
            email:       res.data.email       ? res.data.email :       '',
            mobilePhone: res.data.mobilePhone ? res.data.mobilePhone : '',
            workPhone:   res.data.workPhone   ? res.data.workPhone :   ''
          });

          setNewSecQnA({
            secQuestion: '',
            secAnswer:   '',
            currentPassword2:   ''
          });

          setNewMfaWithEmail(res.data.mfaWithEmail);
          setNewMfaWithSMS(res.data.mfaWithSMS);

          if (res.data.photoInfo) {
            fetchPhoto(res.data.photoInfo.fileType);
          } else {
            setPhotoUrl (null);
          }
        }

        setMainErrMsg('');
      } catch (error) {
        setMainErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const fetchPhoto = (fileType) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("my-photo/",  {
                                                        responseType: "arraybuffer",
                                                      });

        resolve(res.blob);

        if (res.status === 200) {

          const blob = new Blob([new Uint8Array(res.data)], { type: fileType });
          const blobUrl = URL.createObjectURL(blob);

          setPhotoUrl(blobUrl);
        }

        setMainErrMsg('');
      } catch (error) {
        setMainErrMsg(t(translateAPIError(error)));
      }
    });
  }


  function fetchSecQuestions() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("public-config");

        resolve(res.data);

        if (res.status === 200) {
          if (res.data[0] && res.data[0].secQuestions) {
            setSecQuestionList(res.data[0].secQuestions);
          } else {
            setMainErrMsg(t("I18N_ERR_fetch_seq_q_list"));
          }
        }
        setMainErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setMainErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  function fetchPlatformConfig() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("platform-config");

        resolve(res.data);

        if (res.status === 200) {
          setPlatformConfig(res.data[0]);
        }
        setMainErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setMainErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  // Update user info, all updatable fields, except password
  const updateUserProfile = (newUserProfile, setErrMsg) => {

    const reqBody = newUserProfile;

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_IDENT_MGMT_API.put("/my-profile" , reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setUserAttrs(newUserProfile);

          // Restore UI to viewing mode
          setEditModeName(false);
          setEditModeContactInfo(false);
          setEditModeOtherSettings(false);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  // Update password
  const updatePassword = (username, newPassword, currentPassword) => {

    const reqBody = {
      username:        username        ? username.trim()        : username,
      newPassword:     newPassword     ? newPassword.trim()     : newPassword,
      currentPassword: currentPassword ? currentPassword.trim() : currentPassword,
    }

    return new Promise(async (resolve, reject) => {
      setLoading(true); // For loading spinner

      try {
        const res = await axiosAuth_IDENT_MGMT_API.put("my-password", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setLoading(false);
          // Restore UI to viewing mode
          setEditModePassword(false);
        }

        setNewPasswordErrMsg('');
      } catch (error) {
        setLoading(false);
        setNewPasswordErrMsg(t(translateAPIError(error)));
      }
    });
  }

  // Update security question and answer
  const updateSecQnA = () => {

    const reqBody = {
      secQuestion: secQuestionList.find( ({ code }) => code === secQuestion ).displayName[i18n.language],
      secAnswer:   secAnswer,
      password:    currentPassword2
    }

    return new Promise(async (resolve, reject) => {
      setLoading(true); // For loading spinner

      try {
        const res = await axiosAuth_IDENT_MGMT_API.put("my-sec-q-n-a", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setLoading(false);
          // Restore UI to viewing mode
          setEditModeSecQnA(false);
        }

        setNewSecQnAErrMsg('');
      } catch (error) {
        setLoading(false);
        setNewSecQnAErrMsg(t(translateAPIError(error)));
      }
    });
  }

  // Update MFA settings
  const updateMfa = (mfaWithEmail, mfaWithSMS) => {

    const reqBody = {
      username:     user.userInfo.username,
      mfaWithEmail: mfaWithEmail,
      mfaWithSMS:   mfaWithSMS,
      password:     currentPassword3
    }

    return new Promise(async (resolve, reject) => {
      setLoading(true); // For loading spinner

      try {
        const res = await axiosAuth_IDENT_MGMT_API.put("my-mfa", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setLoading(false);

          // Restore UI to viewing mode
          setEditModeMFA(false);

          setNewMfa(
            {
              currentPassword3:   ''
            }
          )
        }

        setNewMfaErrMsg('');
      } catch (error) {
        setLoading(false);
        setNewMfaErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const onNameInputChange = (e) => {
    setNewName({ ...newName, [e.target.name]: e.target.value })
  }

  const onContactInfoInputChange = (e) => {
    setNewContactInfo({ ...newContactInfo, [e.target.name]: e.target.value })
  }

  const onPasswordInputChange = (e) => {
    setNewPassword({ ...newPassword, [e.target.name]: e.target.value })
  }

  const onSecQnAInputChange = (e) => {
    setNewSecQnA({ ...newSecQnA, [e.target.name]: e.target.value })
  }

  const onSeqQuestionSelect = (key, event) => {
    setNewSecQnA({ ...newSecQnA, secQuestion: key })
  };

  const onMfaInputChange = (e) => {
    setNewMfa({ ...newMfa, [e.target.name]: e.target.value })
  }

  const onLngSelect = (key, event) => {
    setNewLng({key: key, value: key});
  };

  // UI Functions

  const handleEditName = (e) => {
    e.preventDefault();
    setEditModeName(true);

    // Close other edit areas to avoid cluttering
    handleEditContactInfoCancel(e);
    handleEditPhotoCancel(e);
    handleChangePasswordCancel(e);
    handleUpdateSecQnACancel(e);
    handleEditMFACancel(e);
    handleEditOtherSettingsCancel(e);
  }

  const handleEditContactInfo = (e) => {
    e.preventDefault();
    setEditModeContactInfo(true);

    // Close other edit areas to avoid cluttering
    handleEditNameCancel(e);
    handleEditPhotoCancel(e);
    handleChangePasswordCancel(e);
    handleUpdateSecQnACancel(e);
    handleEditMFACancel(e);
    handleEditOtherSettingsCancel(e);
  }

  const handleEditPhoto = (e) => {
    e.preventDefault();
    setEditModePhoto(true);

    // Close other edit areas to avoid cluttering
    handleEditNameCancel(e);
    handleEditContactInfoCancel(e);
    handleChangePasswordCancel(e);
    handleUpdateSecQnACancel(e);
    handleEditMFACancel(e);
    handleEditOtherSettingsCancel(e);

    setNewPhotoErrMsg("");
  }

  const handleEditOtherSettings = (e) => {
    e.preventDefault();
    setEditModeOtherSettings(true);
    setNewLng({key: userAttrs.language, value: userAttrs.language});

    // Close other edit areas to avoid cluttering
    handleEditNameCancel(e);
    handleEditContactInfoCancel(e);
    handleEditPhotoCancel(e);
    handleChangePasswordCancel(e);
    handleUpdateSecQnACancel(e);
    handleEditMFACancel(e);
  }

  const handleEditPassword = (e) => {
    e.preventDefault();
    setEditModePassword(true);

    // Close other edit areas to avoid cluttering
    handleEditNameCancel(e);
    handleEditContactInfoCancel(e);
    handleEditPhotoCancel(e);
    handleUpdateSecQnACancel(e);
    handleEditMFACancel(e);
    handleEditOtherSettingsCancel(e);
  }

  const handleEditSecQnA = (e) => {
    e.preventDefault();
    setEditModeSecQnA(true);

    // Close other edit areas to avoid cluttering
    handleEditNameCancel(e);
    handleEditContactInfoCancel(e);
    handleEditPhotoCancel(e);
    handleChangePasswordCancel(e);
    handleEditMFACancel(e);
    handleEditOtherSettingsCancel(e);
  }

  const handleEditMFA = (e) => {
    e.preventDefault();
    setEditModeMFA(true);

    // Close other edit areas to avoid cluttering
    handleEditNameCancel(e);
    handleEditContactInfoCancel(e);
    handleEditPhotoCancel(e);
    handleChangePasswordCancel(e);
    handleUpdateSecQnACancel(e);
    handleEditOtherSettingsCancel(e);
  }


  const handleEditNameCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setNewName({
      surname:    userAttrs.surname    ? userAttrs.surname    : '',
      givenName:  userAttrs.givenName  ? userAttrs.givenName  : '',
      middleName: userAttrs.middleName ? userAttrs.middleName : ''
    });

    setEditModeName(false);
    setNewNameErrMsg('');
  }

  const handleEditNameSubmit = (e) => {
    e.preventDefault();

    // Validate fields
/* ### SHKP requested not to require  names ###
    if (!newName.surname || newName.surname.length === 0) {
      setNewNameErrMsg(t("I18N_ERR_Need_Surname"));
    } else if (!newName.givenName || newName.givenName.length === 0) {
      setNewNameErrMsg(t("I18N_ERR_Need_Given_name"));
    } else {
*/
    if (newName.surname && newName.surname.length > 30) {
      setNewNameErrMsg(t("I18N_ERR_Max_len_surname") + 30);
    } else if (newName.givenName && newName.givenName.length > 30) {
      setNewNameErrMsg(t("I18N_ERR_Max_len_given_name") + 30);
    } else if (newName.middleName && newName.middleName.length > 30) {
      setNewNameErrMsg(t("I18N_ERR_Max_len_middle_name") + 30);
    } else {
      setNewNameErrMsg('');

      let newUserProfile = userAttrs;

      newUserProfile.surname    = newName.surname;
      newUserProfile.givenName  = newName.givenName;
      newUserProfile.middleName = newName.middleName;

      updateUserProfile(newUserProfile, setNewNameErrMsg);
      setUserAttrs(newUserProfile);
    }
  }

  const handleEditContactInfoCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setNewContactInfo({
      email:       userAttrs.email        ? userAttrs.email        : '',
      mobilePhone: userAttrs.mobilePhone  ? userAttrs.mobilePhone  : '',
      workPhone:   userAttrs.workPhone    ? userAttrs.workPhone    : ''
    });

    setEditModeContactInfo(false);
    setNewContactInfoErrMsg('');
  }

  const handleEditContactInfoSubmit = (e) => {
    e.preventDefault();

    // Validate fields
    if (!newContactInfo.email || newContactInfo.email.length === 0) {
      setNewContactInfoErrMsg(t("I18N_ERR_Need_Email"));
    } else if (!validateEmail(newContactInfo.email)) {
      setNewContactInfoErrMsg(t("I18N_ERR_Bad_Email"));
    } else if (newContactInfo.email.length > 60) {
      setNewContactInfoErrMsg(t("I18N_ERR_Max_len_email") + 60);
/*
    } else if (!newContactInfo.mobilePhone || newContactInfo.mobilePhone.length === 0) {
      setNewContactInfoErrMsg(t("I18N_ERR_Need_Mobile_Phone"));
*/
    } else {
      setNewContactInfoErrMsg('');

      let newUserProfile = JSON.parse(JSON.stringify(userAttrs));

      newUserProfile.email       = newContactInfo.email;
      newUserProfile.mobilePhone = newContactInfo.mobilePhone;
      newUserProfile.workPhone   = newContactInfo.workPhone;

      updateUserProfile(newUserProfile, setNewContactInfoErrMsg);
    }
  }

  const handleEditOtherSettingsCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setNewLng({});

    setEditModeOtherSettings(false);
  }

  const handleEditOtherSettingsSubmit = (e) => {
    e.preventDefault();

    if (!newLng || newLng.length === 0) {
      setNewOtherSettingsErrMsg(t("I18N_ERR_Need_lang"));
    } else {
      setNewOtherSettingsErrMsg('');

      let newUserProfile = JSON.parse(JSON.stringify(userAttrs));

      newUserProfile.language = newLng.value;
      i18n.changeLanguage(newLng.value);

      updateUserProfile(newUserProfile, setNewOtherSettingsErrMsg);
    }
  }

  const handleChangePasswordCancel = (e) => {
    e.preventDefault();
    setEditModePassword(false);

    setHideCurrentPwd(true);
    setHideNewPwd(true);
    setHideConfirmPwd(true);

    setNewPasswordErrMsg('');
  }

  const handleChangePasswordSubmit = (e) => {
    e.preventDefault();

    if (!newPassword.password || newPassword.password.length === 0) {
      setNewPasswordErrMsg(t("I18N_ERR_Need_Password"));
    } else if (!validatePwdComplexity(newPassword.password)) {
      setNewPasswordErrMsg(t("I18N_ERR_Poor_Password"));
    } else if (newPassword.confirmPassword !== newPassword.password) {
      setNewPasswordErrMsg(t("I18N_ERR_Pass_Mismatch"));
    } else if (!newPassword.currentPassword || newPassword.currentPassword.length === 0) {
      setNewPasswordErrMsg(t("I18N_ERR_Need_Curr_Pwd"));
    } else {
      updatePassword(userAttrs.username, newPassword.password, newPassword.currentPassword);
    }

    setHideCurrentPwd(true);
    setHideNewPwd(true);
    setHideConfirmPwd(true);
  }

  function validatePwdComplexity (password) {
    // Password policy: Min length, upper case, lower case, special char, etc.
    //let strongPassword = new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+={\}[\]|\\:;"\'<>,.?/]).{12,30}$');
    let strongPassword = new RegExp(decodeURIComponent(platformConfig.config.public.pwdComplexity.testRegExp));

    if (!strongPassword.test(password)) {
      return (false);
    } else {
      return (true);
    }
  }

  const handleUpdateSecQnACancel = (e) => {
    e.preventDefault();
    setEditModeSecQnA(false);
    setHideCurrentPwd2(true);
    setNewSecQnA(
      {
        secQuestion: '',
        secAnswer:   '',
        currentPassword2:   ''
      }
    );
    setNewSecQnAErrMsg('');
  }

  const handleUpdateSecQnASubmit = (e) => {
    e.preventDefault();

    if (!newSecQnA.secQuestion || newSecQnA.secQuestion.length === 0) {
      setNewSecQnAErrMsg(t("I18N_ERR_Need_Sec_Q"));
    } else if (!newSecQnA.secAnswer || newSecQnA.secAnswer.length === 0) {
      setNewSecQnAErrMsg(t("I18N_ERR_Need_Sec_A"));
    } else if (!newSecQnA.currentPassword2 || newSecQnA.currentPassword2.length === 0) {
      setNewSecQnAErrMsg(t("I18N_ERR_Need_Curr_Pwd"));
    } else {
      updateSecQnA();
    }

    setHideCurrentPwd2(true);
  }

  const handleEditMFACancel = (e) => {
    e.preventDefault();

    setNewMfaWithEmail(userAttrs.mfaWithEmail);
    setNewMfaWithSMS(userAttrs.mfaWithSMS);

    setNewMfa({ ...newMfa, 'currentPassword3': ''})

    setEditModeMFA(false);
    setHideCurrentPwd3(true);
    setNewMfaErrMsg('');
  }

  const handleEditMFASubmit = (e) => {
    e.preventDefault();

    updateMfa(newMfaWithEmail, newMfaWithSMS);

    setHideCurrentPwd3(true);
  }

  const navigate = useNavigate();

  const handleClose = (e) => {
    e.preventDefault();

    navigate("/AdminHome/Dashboard", {
      state: {
        //...values
        target: 'Dashboard'
      }
    });
  }

  const handleToggleNewPwd = (e) => {
    e.preventDefault();
    setHideNewPwd(!hideNewPwd);
  }

  const handleToggleConfirmPwd = (e) => {
    e.preventDefault();
    setHideConfirmPwd(!hideConfirmPwd);
  }

  const handleToggleCurrentPwd = (e) => {
    e.preventDefault();
    setHideCurrentPwd(!hideCurrentPwd);
  }

  const handleToggleCurrentPwd2 = (e) => {
    e.preventDefault();
    setHideCurrentPwd2(!hideCurrentPwd2);
  }

  const handleToggleCurrentPwd3 = (e) => {
    e.preventDefault();
    setHideCurrentPwd3(!hideCurrentPwd3);
  }


  // --- Edit Photo ---

  const handleEditPhotoCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setNewPhotoInfo({
      fileType: '',
      fileExt : '',
      size: 0,
      data: null
    });

    setEditModePhoto(false);
    setNewPhotoErrMsg('');
  }

  const handleEditPhotoSubmit = (e) => {
    e.preventDefault();

    if (!newPhotoInfo.name || newPhotoInfo.name.length === 0) {
      setNewPhotoErrMsg(t("I18N_ERR_Need_select_file"));
      return;
    }

    setNewPhotoErrMsg('');

    // Update photo
    const formData = new FormData();
    const photoInfo = {
            "fileExt":  newPhotoInfo.fileExt,
            "fileType": newPhotoInfo.fileType,
            "size":     newPhotoInfo.size
          }

    formData.append('photoInfo', JSON.stringify(photoInfo));
    formData.append('file',      newPhotoInfo.selectedFile);

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.post("my-photo/", formData, {
                      headers: { 'Content-Type': 'multipart/form-data' }
                    });

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditModePhoto(false);

          setNewPhotoInfo({
            fileType: '',
            fileExt : '',
            size: 0,
            data: null
          });

          setPhotoUrl(null);

          fetchUserAttrs(user.userInfo.username);
        }

        setNewPhotoErrMsg('');
      } catch (error) {
        setNewPhotoErrMsg(t(translateAPIError(error)));
      }
    });

  }


  // --- Photo file handling ---

  const handleFileChange = (event) => {

    // Protect from Cancel event where the event.target.files[0] is not defined.
    if (event.target && event.target.files[0]) {

      // Check to see if file size exceeds limit (64 KB for now, which is the BLOB limit)
      if (event.target.files[0].size > (64 * 1024.0)) {
        setNewPhotoErrMsg(t("I18N_ERR_File_size_exceed_limit") + "64 KB");
        return;
      } else if (!event.target.files[0].type.includes("image/")) {
        setNewPhotoErrMsg(t("I18N_ERR_Needs_img_file"));
        return;
      } else {
        setNewPhotoErrMsg('');
      }

      let photoInfo = {
            selectedFile: event.target.files[0],
            name:         event.target.files[0].name,
            fileType:     event.target.files[0].type,
            fileExt:      getSubstringAfterLastPeriod(event.target.files[0].name),
            size:         event.target.files[0].size
          }

      setNewPhotoInfo(photoInfo);
    }
  };

  function getSubstringAfterLastPeriod(str) {
    const lastPeriodIndex = str.lastIndexOf('.');
    if (lastPeriodIndex === -1) {
      // No period found, return the null
      return (null);
    }
    return str.substring(lastPeriodIndex + 1);
  }



  // --- Delete photo ---

  const handleDeletePhoto = (e) => {
    e.preventDefault();
    setShowDeleteConfirmDialog(true);
  }

  function handleObjDeleteCancel() {
    setShowDeleteConfirmDialog(false);
  }

  function handleObjDeleteSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.delete("my-photo/");

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setShowDeleteConfirmDialog(false);

          fetchUserAttrs(user.userInfo.username);
        }

        setErrMsgDeleteConfirm('');
      } catch (error) {
        setErrMsgDeleteConfirm(t(translateAPIError(error)));
      }
    });
  }



  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div className={classes.admin_pages__page_title}>
          {t("I18N_Your_user_profile")}
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_General_info")}
            </span>
          </div>
          <hr className="solid" style={{margin:'0 0 10px 0'}}></hr>

          <Container>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Username")}:</Col>
{/* Should not be needed for User Profile
              <Col>{t("I18N_User_type")}:</Col>
*/}
              <Col>{t("I18N_Time_created")}:</Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>{userAttrs.username}</Col>
{/* Should not be needed for User Profile
              <Col>{t("common:I18N_" + userAttrs.userType)}</Col>
*/}
              <Col>{formatDate(userAttrs.timeCreated)}</Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
              <Col>{t("I18N_Job_title")}:</Col>
              <Col>{t("I18N_Dept_name")}:</Col>
              <Col>{t("I18N_Emp_id")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>{userAttrs.jobTitle}</Col>
              <Col>
                { (i18n.language === 'en') ? userAttrs.deptName : (i18n.language === 'zh_HK' ? userAttrs.deptNameLang2 : userAttrs.deptNameLang3) }
              </Col>
              <Col>{userAttrs.empId}</Col>
            </Row>
          </Container>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Name_details")}
            </span>
            {editModeName || !configInfo.uiConfig.editableFields.USERPROFILE_Names ?
              null
            :
              <span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditName}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{margin:'0 0 10px 0'}}></hr>

          {editModeName ?
            <Container>
              <form style={{borderColor:'lightgray'}}>
                <Row className={classes.admin_pages__field_label} style={{marginTop:'15px'}}>
                  <Col>{t("I18N_Surname")}:</Col>
                  <Col>{t("I18N_Given_name")}:</Col>
                  <Col>{t("I18N_Middle_name")}:</Col>
                </Row>
                <Row >
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="surname" value={surname}
                           onChange={(e) => onNameInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="givenName" value={givenName}
                           onChange={(e) => onNameInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="middleName" value={middleName}
                           onChange={(e) => onNameInputChange(e)} />
                  </Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{marginTop:'8px'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'20px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                            style={{float:'left'}}
                            onClick={handleEditNameCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                            style={{marginLeft:'15px'}}
                            onClick={handleEditNameSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {newNameErrMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
          :
            <Container>
              <Row className={classes.admin_pages__field_label} style={{marginTop:'15px'}}>
                <Col>{t("I18N_Surname")}:</Col>
                <Col>{t("I18N_Given_name")}:</Col>
                <Col>{t("I18N_Middle_name")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{userAttrs.surname}</Col>
                <Col>{userAttrs.givenName}</Col>
                <Col>{userAttrs.middleName}</Col>
              </Row>
            </Container>
          }
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
             {t("I18N_Contact_info")}
            </span>
            {editModeContactInfo || !configInfo.uiConfig.editableFields.USERPROFILE_Contact ?
              null
            :
/*
              userAttrs.userType !== 'UTYPE_SYSADMIN' ?
                <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditContactInfo}>
                  <PencilIcon size={12} />
                  {t("I18N_Edit")}
                </span>
              :
                <span style={{ marginLeft: '15px', fontSize: '10px', fontWeight: '400', color: 'black' }}>
                  ({t("I18N_Must_update_by_peer")})
                </span>
*/
              < span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditContactInfo}>
                <PencilIcon size={12} />
                 {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{margin:'0 0 10px 0'}}></hr>

          {editModeContactInfo ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Email")}: *</Col>
                  <Col>{t("I18N_Mobile_phone")}:</Col>
                  <Col>{t("I18N_Work_phone")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="email" value={email}
                           onChange={(e) => onContactInfoInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="mobilePhone" value={mobilePhone}
                           onChange={(e) => onContactInfoInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="workPhone" value={workPhone}
                           onChange={(e) => onContactInfoInputChange(e)} />
                  </Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{marginTop:'8px'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'20px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                            style={{float:'left'}}
                            onClick={handleEditContactInfoCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                            style={{marginLeft:'15px'}}
                            onClick={handleEditContactInfoSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {newContactInfoErrMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
          :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                 <Col>{t("I18N_Email")}:</Col>
                <Col>{t("I18N_Mobile_phone")}:</Col>
                <Col>{t("I18N_Work_phone")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{userAttrs.email}</Col>
                <Col>{userAttrs.mobilePhone}</Col>
                <Col>{userAttrs.workPhone}</Col>
              </Row>
            </Container>
          }
        </div>



        { configInfo.uiConfig.visibleFields.USERPROFILE_photo ?
        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <div display='flex'>
            <span>
              {t("I18N_Photo")}
            </span>
            {editModePhoto || (!configInfo.appConfig.isPrimaryIdentProvider && userAttrs.accountType === 'USER') ?
              null
              :
              <>
                <span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditPhoto}>
                  <PencilIcon size={12} />
                  {t("I18N_Edit")}
                </span>
                { photoUrl ?
                  <span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleDeletePhoto}>
                    <BiTrash size={12} />
                    {t("I18N_Delete")}
                  </span>
                  : null
                }
              </>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editModePhoto ?
            <Container>
              <Form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_File_name")} ({t("I18N_Max_file_size")} 64KB): * </Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={newPhotoInfo.name} />
                  </Col>
                  <Col>
                    <div>
                      <input
                        type="file"
                        style={{ display: 'none' }}
                        id="fileInput"
                        onChange={handleFileChange}
                      />
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                              onClick={() => document.getElementById('fileInput').click()} >
                        {t("I18N_Choose_file")}
                      </Button>
                    </div>
                  </Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>
                <Row>
                  <Col md={2}>
                    <div display='flex' style={{marginTop:'15px'}}>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ float: 'left' }}
                        onClick={handleEditPhotoCancel}>
                        {t("I18N_Cancel")}
                      </Button>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ marginLeft: '15px' }}
                        onClick={handleEditPhotoSubmit}>
                        {t("I18N_Save")}
                      </Button>
                    </div>
                  </Col>
                  <Col md={10} style={{marginTop:'15px'}}>
                    <span className={classes.admin_pages__field_label} style={{color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {newPhotoErrMsg}
                    </span>
                  </Col>
                </Row>
              </Form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_value}>
              { photoUrl ?
                <Col><img src={photoUrl} width='100px' alt="Profile" /></Col>
              :
                <Col>{t("I18N_No_photo")}</Col>
              }
              </Row>
            </Container>
          }
        </div>
        : null
        }


        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
             {t("I18N_Other_settings")}
            </span>
            {editModeOtherSettings ?
              null
            :
/*
              userAttrs.userType !== 'UTYPE_SYSADMIN' ?
                <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditOtherSettings}>
                  <PencilIcon size={12} />
                  {t("I18N_Edit")}
                </span>
              :
                <span style={{ marginLeft: '15px', fontSize: '10px', fontWeight: '400', color: 'black' }}>
                  ({t("I18N_Must_update_by_peer")})
                </span>
*/
              < span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditOtherSettings}>
                <PencilIcon size={12} />
                 {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{margin:'0 0 10px 0'}}></hr>

          {editModeOtherSettings ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_UI_language")}: *</Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={t("I18N_Lng_" + newLng.value)}
                      onSelect={onLngSelect}>
                      {lngList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_Lng_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{marginTop:'8px'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'20px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                            style={{float:'left'}}
                            onClick={handleEditOtherSettingsCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                            style={{marginLeft:'15px'}}
                            onClick={handleEditOtherSettingsSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {newOtherSettingsErrMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
          :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_UI_language")}:</Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{t("I18N_Lng_" + userAttrs.language)}</Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
            </Container>
          }
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
             {t("I18N_Manage_auth")}
            </span>
          </div>

          <hr className="solid" style={{margin:'0 0 10px 0'}}></hr>
          <Container>
            <div display='flex'>
              {editModePassword ?
                <div>
                  <Row className={classes.admin_pages__page_subtitle}>
                    <span>{t("I18N_Change_pwd")}</span>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '5px' }}>
                    <span>{t("I18N_Current_pwd")}: *</span>
                  </Row>
                  <Row className={classes.admin_pages__field_label}>
{/*
                    <span>
                      <input className={classes.admin_pages__field_editable} type="password" name="currentPassword" value={currentPassword}
                        onChange={(e) => onPasswordInputChange(e)} />
                    </span>
*/}
                    <Col sm={3} style={{ position:'relative'}}>
                      { hideCurrentPwd ?
                        <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="password" name="currentPassword" value={currentPassword}
                          onChange={(e) => onPasswordInputChange(e)} />
                      :
                        <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="text"     name="currentPassword" value={currentPassword}
                          onChange={(e) => onPasswordInputChange(e)} />
                      }
                      <span onClick={handleToggleCurrentPwd} style={{ marginLeft:'-60px', cursor:'pointer', color:'rgb(100,100,100)', position:'absolute', top:'0', right:'20px'}}>
                        { hideCurrentPwd ?
                          <BiHide size={15} style={{marginTop:'4px'}} />
                        :
                          <BiShow size={15} style={{marginTop:'4px'}} />
                        }
                      </span>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '5px' }}>
                    <Col>{t("I18N_New_pwd")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_label}>
                    <Col sm={3} style={{ position:'relative'}}>
{/*
                      <input className={classes.admin_pages__field_editable} type="password" name="password" value={password}
                        onChange={(e) => onPasswordInputChange(e)} />
*/}
                      { hideNewPwd ?
                        <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="password" name="password" value={password}
                          onChange={(e) => onPasswordInputChange(e)} />
                      :
                        <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="text"     name="password" value={password}
                          onChange={(e) => onPasswordInputChange(e)} />
                      }
                      <span onClick={handleToggleNewPwd} style={{ marginLeft:'-60px', cursor:'pointer', color:'rgb(100,100,100)', position:'absolute', top:'0', right:'20px'}}>
                        { hideNewPwd ?
                          <BiHide size={15} style={{marginTop:'4px'}} />
                        :
                          <BiShow size={15} style={{marginTop:'4px'}} />
                        }
                      </span>
                    </Col>
                      { platformConfig && platformConfig.config ?
                         configInfo.uiConfig.visibleFields.USERPROFILE_pwdHint ?
                          <Col sm={6} >
                            <span>
                              { i18n.language === 'en'    ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.en)    :
                                i18n.language === 'zh_HK' ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.zh_HK) :
                                i18n.language === 'zh_CN' ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.zh_CN) :
                                decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.en) }
                            </span>
                          </Col>
                        :
                          <Col sm={1} >
                            <OverlayTrigger overlay={<Tooltip id="tooltip-pwd-complexity" style={{fontSize:'11px'}}>
                                                       { i18n.language === 'en'    ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.en)    :
                                                         i18n.language === 'zh_HK' ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.zh_HK) :
                                                         i18n.language === 'zh_CN' ? decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.zh_CN) :
                                                         decodeURIComponent(platformConfig.config.public.pwdComplexity.hint.en) }
                                                       </Tooltip>}>
                              <span style={{marginLeft:'-10px', cursor:'pointer'}}>
                                <BiHelpCircle size={15} />
                              </span>
                            </OverlayTrigger>
                          </Col>
                      : null
                      }
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '5px' }}>
                    <span>{t("I18N_Confirm_password")}: *</span>
                  </Row>
                  <Row className={classes.admin_pages__field_label}>
{/*
                    <span>
                      <input className={classes.admin_pages__field_editable} type="password" name="confirmPassword" value={confirmPassword}
                        onChange={(e) => onPasswordInputChange(e)} />
                    </span>
*/}
                    <Col sm={3} style={{ position:'relative'}}>
                      { hideConfirmPwd ?
                        <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="password" name="confirmPassword" value={confirmPassword}
                          onChange={(e) => onPasswordInputChange(e)} />
                      :
                        <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="text"     name="confirmPassword" value={confirmPassword}
                          onChange={(e) => onPasswordInputChange(e)} />
                      }
                      <span onClick={handleToggleConfirmPwd} style={{ marginLeft:'-60px', cursor:'pointer', color:'rgb(100,100,100)', position:'absolute', top:'0', right:'20px'}}>
                        { hideConfirmPwd ?
                          <BiHide size={15} style={{marginTop:'4px'}} />
                        :
                          <BiShow size={15} style={{marginTop:'4px'}} />
                        }
                      </span>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'8px', fontStyle:'italic'}}>
                    <span>{t("I18N_Req_fields")}</span>
                  </Row>
                  <Row>
                    <div display='flex' style={{ marginTop: '15px' }}>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{float:'left'}}
                        onClick={handleChangePasswordCancel}>
                        {t("I18N_Cancel")}
                      </Button>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{marginLeft:'15px'}}
                        onClick={handleChangePasswordSubmit}>
                        {t("I18N_Save")}
                      </Button>
                      <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                        {newPasswordErrMsg}
                      </span>
                    </div>
                  </Row>
                </div>
              :
                <div>
                  <span className={classes.admin_pages__field_label}>
                    {t("I18N_Password")}
                  </span>
{/*
                  {userAttrs.userType !== 'UTYPE_SYSADMIN' ?
                    <span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditPassword}>
                      <PencilIcon size={10} />
                      {t("I18N_Edit")}
                    </span>
                  :
                    <span style={{ marginLeft: '15px', fontSize: '10px', fontWeight: '400', color: 'black' }}>
                      ({t("I18N_Must_update_by_peer")})
                    </span>
                  }
*/}
                  <span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditPassword}>
                    <PencilIcon size={10} />
                    {t("I18N_Edit")}
                  </span>
                </div>
              }
            </div>

            <div display='flex' style={{marginTop:'8px'}}>
              {editModeSecQnA ?
                <div>
                  <Row className={classes.admin_pages__page_subtitle}>
                    <span>{t("I18N_Sec_Q_and_A")}</span>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '5px' }}>
                    <span>{t("I18N_Current_pwd")}: *</span>
                  </Row>
                  <Row className={classes.admin_pages__field_label}>
                    <Col sm={3} style={{ position:'relative'}}>
                      { hideCurrentPwd2 ?
                        <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="password" name="currentPassword2" value={currentPassword2}
                          onChange={(e) => onSecQnAInputChange(e)} />
                      :
                        <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="text"     name="currentPassword2" value={currentPassword2}
                          onChange={(e) => onSecQnAInputChange(e)} />
                      }
                      <span onClick={handleToggleCurrentPwd2} style={{ marginLeft:'-60px', cursor:'pointer', color:'rgb(100,100,100)', position:'absolute', top:'0', right:'20px'}}>
                        { hideCurrentPwd2 ?
                          <BiHide size={15} style={{marginTop:'4px'}} />
                        :
                          <BiShow size={15} style={{marginTop:'4px'}} />
                        }
                      </span>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '5px' }}>
                    <span>{t("I18N_Sec_question")}: *</span>
                  </Row>
                  <Row className={classes.admin_pages__field_label}>
                    <Col sm={3}>
{/*
                      <textarea rows={2} className={classes.admin_pages__field_editable} type="text" name="secQuestion" value={secQuestion}
                        onChange={(e) => onSecQnAInputChange(e)} />
*/}
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={((!secQuestion) || (secQuestion.length === 0)) ? t("common:I18N_DROPDOWN_PROMPT") :
                               secQuestionList.find( ({ code }) => code === secQuestion ).displayName[i18n.language] }
                        style={{marginTop: '5px'}}
                        onSelect={onSeqQuestionSelect}>
                        {secQuestionList.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.code}  style={{minWidth: '100%',fontSize:'13px'}}>
                              {item.displayName[i18n.language]}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '5px' }}>
                    <span>{t("I18N_Sec_answer")}: *</span>
                  </Row>
                  <Row className={classes.admin_pages__field_label}>
                    <Col sm={3}>
                    <span>
                      <input style={{width:'100%'}} className={classes.admin_pages__field_editable} type="text" name="secAnswer" value={secAnswer}
                        onChange={(e) => onSecQnAInputChange(e)} />
                    </span>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'8px', fontStyle:'italic'}}>
                    <span>{t("I18N_Req_fields")}</span>
                  </Row>
                  <Row>
                    <div display='flex' style={{ marginTop: '15px' }}>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{float:'left'}}
                        onClick={handleUpdateSecQnACancel}>
                        {t("I18N_Cancel")}
                      </Button>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{marginLeft:'15px'}}
                        onClick={handleUpdateSecQnASubmit}>
                        {t("I18N_Save")}
                      </Button>
                      <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                        {newSecQnAErrMsg}
                      </span>
                    </div>
                  </Row>
                </div>
              :
                !configInfo.appConfig.isSimpleUserCreation ?
                  <>
                    {userAttrs.userType !== 'UTYPE_SYSADMIN' ?
                      <div>
                        <span className={classes.admin_pages__field_label}>
                          {t("I18N_Sec_Q_and_A")}
                        </span>
                        <span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditSecQnA}>
                          <PencilIcon size={10} />
                          {t("I18N_Edit")}
                        </span>
                      </div>
                    : null
                    }
                  </>
                  : null
              }
            </div>

            <div style={{marginTop:'8px'}}>
              <div display='flex'>
                {editModeMFA ?
                  <>
                    <Row className={classes.admin_pages__page_subtitle}>
                      <span>{t("I18N_MFA")}</span>
                    </Row>

                    <Row className={classes.admin_pages__field_label} style={{ marginTop: '5px' }}>
                      <span>{t("I18N_Current_pwd")}: *</span>
                    </Row>
                    <Row className={classes.admin_pages__field_label}>
                      <Col sm={3} style={{ position:'relative'}}>
                        { hideCurrentPwd3 ?
                          <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="password" name="currentPassword3" value={currentPassword3}
                            onChange={(e) => onMfaInputChange(e)} />
                        :
                          <input style={{width:"100%"}} className={classes.admin_pages__field_editable} type="text"     name="currentPassword3" value={currentPassword3}
                            onChange={(e) => onMfaInputChange(e)} />
                        }
                        <span onClick={handleToggleCurrentPwd3} style={{ marginLeft:'-60px', cursor:'pointer', color:'rgb(100,100,100)', position:'absolute', top:'0', right:'20px'}}>
                          { hideCurrentPwd3 ?
                            <BiHide size={15} style={{marginTop:'4px'}} />
                          :
                            <BiShow size={15} style={{marginTop:'4px'}} />
                          }
                        </span>
                      </Col>
                    </Row>
                  </>
                :
                !configInfo.appConfig.isSimpleUserCreation ?
                  <>
{/*
<>
                  userAttrs.userType !== 'UTYPE_SYSADMIN' ?
                    <span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditMFA}>
                      <PencilIcon size={10} />
                      {t("I18N_Edit")}
                    </span>
                  :
                    <span style={{ marginLeft: '15px', fontSize: '10px', fontWeight: '400', color: 'black' }}>
                      ({t("I18N_Must_update_by_peer")})
                    </span>
</>
*/}
                  <span className={classes.admin_pages__field_label}>
                  {t("I18N_MFA")}
                  </span>
                  <span style={{ marginLeft: '15px', fontSize: '9px', color: 'SteelBlue', cursor: 'pointer' }} onClick={handleEditMFA}>
                    <PencilIcon size={10} />
                    {t("I18N_Edit")}
                  </span>
                  </>
                  : null
                }
              </div>

              {  !configInfo.appConfig.isSimpleUserCreation ?
              <Form className={classes.admin_pages__field_value} style={{margin:'10px 0 0 10px'}}>
                <>
                <Form.Check
                  disabled={!editModeMFA}
                  type="switch"
                  id="mfa-email"
                  label={t("I18N_MFA_via_email")}
                  checked={newMfaWithEmail}
                  onChange={() => {
                                    setNewMfaWithEmail(!newMfaWithEmail)
                                  }}
                />
{/*
                <Form.Check
                  disabled={!editModeMFA}
                  type="switch"
                  id="mfa-sms"
                  label={t("I18N_MFA_via_sms")}
                  checked={newMfaWithSMS}
                  onChange={() => {
                                    setNewMfaWithSMS(!newMfaWithSMS)
                                  }}
                />
*/}
                </>
              </Form>
              : null
              }

              {editModeMFA ?
                <>
{/*
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '5px' }}>
                    <span>{t("I18N_Password")}: *</span>
                    <span>
                      <input className={classes.admin_pages__field_editable} type="password" name="currentPassword3" value={currentPassword3}
                        onChange={(e) => onMfaInputChange(e)} />
                    </span>
                  </Row>
*/}
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '8px', fontStyle:'italic' }}>
                    <span>{t("I18N_Req_fields")}</span>
                  </Row>
                  <Row>
                    <div display='flex' style={{ marginTop: '15px' }}>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ float: 'left' }}
                        onClick={handleEditMFACancel}>
                        {t("I18N_Cancel")}
                      </Button>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ marginLeft: '15px' }}
                        onClick={handleEditMFASubmit}>
                        {t("I18N_Save")}
                      </Button>
                      <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                        {newMfaErrMsg}
                      </span>
                    </div>
                  </Row>
                </>
              :
                null
              }

            </div>
          </Container>
        </div>

        <hr className="solid" style={{marginTop:'30px'}}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top' }}>
             {mainErrMsg}
          </span>
          <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{float:'right', fontSize:'12px', fontWeight:'300'}}
                  onClick={handleClose}>
            {t("I18N_Close")}
          </Button>
        </div>

        <LoadingSpinner loading={loading} />

        <DeleteConfirmDialog
          title={t("I18N_Photo_del_confirm")}
          show={showDeleteConfirmDialog}
          targetName={''}
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleObjDeleteCancel}
          onSubmit={handleObjDeleteSubmit}
        />

      </Card>
    </>
  );
}


const UserProfile = () => {

  return (
    <Fragment>

      <UserProfileBody />

    </Fragment>
  )
}

export default UserProfile;
